import { requester } from "src/libraries/requester";
import { links } from "src/Links";
import { INewsClient } from "./INewsClient";
import { ApiService } from "src/repository/ApiService";
import { newsClientModel } from "./NewsClientModel";

export const newsClientService = new ApiService<INewsClient>(requester, links.newsClient, newsClientModel);
